import {ua,qs,getScript} from './browser';
import {setCookie} from './cookie';
import {debug} from './message';
const sdklist = {
    'wx' : '//res.wx.qq.com/open/js/jweixin-1.3.2.js',
    'qq' : '//qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js',
    'baidu' : '//b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.20.js',
    'alipay' : 'https://appx/web-view.min.js', //支付宝必须要这么写
    'kuaishou' : '//kuaishou.js',
}

const miniInit = (cb) => {
    return new Promise((resolve, reject) => {
        //1.设置cookie
        if (ua['miniprogram']) {
            setCookie('passToken',qs['session']||'');
            setCookie('session',qs['session']||'');
        }

        //2.加载sdk
        var url = '';
        if (ua['wechatmini']) url = sdklist.wx;
        if (ua['qqmini'])  url = sdklist.qq;
        if (ua['baidumini'])  url = sdklist.baidu;
        if (ua['alipaymini'])  url = sdklist.alipay;
        if (ua['kuaishoumini'])  url = sdklist.kuaishou;

        if (url) {
            getScript(url,function(){
                console.log('mini-sdk loaded')
                resolve();
                cb && cb();
            })
        } else {
            resolve();
        }
    })
}
/*
    mini_action_type : 
        navigateTo (default)
        redirectTo 
        navigateBack
*/
const miniNav = (url, opt={}) => {
    let { mini_action_type='navigateTo' } = opt;
    //微信小程序
    if (ua.wechatmini) {
        wx.miniProgram[mini_action_type]({url: url})
        debug(`[wechatmini-${mini_action_type}]`,url);
    }
    //qq小程序
    if (ua.qqmini) { 
        qq.miniProgram[mini_action_type]({url: url})
        debug(`[qqmini-${mini_action_type}]`,url);
    }
    //baidu小程序
    if (ua.baidumini) {
        swan.webView[mini_action_type]({url: url})
        debug(`[baidumini-${mini_action_type}]`,url);
    }
    //支付宝小程序
    if (ua.alipaymini) {
        my[mini_action_type]({url: url})
        debug(`[alipaymini-${mini_action_type}]`,url);
    }
    //快手小程序
    if (ua.kuaishoumini) {
        ks[mini_action_type]({url: url})
        debug(`[kuaishoumini-${mini_action_type}]`,url);
    }
}
export {
    miniInit,
    miniNav,
}






// WEBPACK FOOTER //
// ./node_modules/@kkmh/utils/src/miniprogram.js